module.exports = __webpack_public_path__ + "media/images/landing/en/planning@2x-60bf76cbfde0f24af100dcde48f09a3c.webp";